import React from "react";
import {faEnvelope, faLocationDot, faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function Contatti() {
    return (
        <section className="py-5 darkerContainer bottom-margin-50">
            <div className="container">
                <h2 className="mb-4">Contatti</h2>

                <div className={'top-margin-5 bottom-margin-15'}>
                    <FontAwesomeIcon icon={faEnvelope} size="1x" className="mb-1 white-color" />
                    <span className={'white-color left-margin-5'}>E-mail: <a className={'light-color'} href="mailto:cmontis@tiscali.it">cmontis@tiscali.it</a></span>
                </div>

                <div className={'top-margin-5 bottom-margin-15'}>
                    <FontAwesomeIcon icon={faPhone} size="1x" className="mb-1 white-color" />
                    <span className={'white-color left-margin-5'}>Telefono: <span className={'light-color'}>+39 345.258.39.21</span></span>
                </div>

                <div className={'top-margin-5 bottom-margin-15'}>
                    <FontAwesomeIcon icon={faLocationDot} size="1x" className="mb-1 white-color" />
                    <span className={'white-color left-margin-5'}>Indirizzo: <span className={'light-color'}>Via Crema 15, 20135 Milano (MI)</span></span>
                </div>

                <iframe title={'Google Maps'} className={'map'} style={{ border: 0}}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11196.06143053736!2d9.19263043400919!3d45.44934663910322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c4228f8372b9%3A0x7cbf5cd48d3de37!2sVia%20Crema%2C%2015%2C%2020135%20Milano%20MI!5e0!3m2!1sit!2sit!4v1765743709776!5m2!1sit!2sit"
                    width="100%" height="450" allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </section>
    );
}

export default Contatti;